var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessThan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M13.287 5.958a1 1 0 0 0-.574-1.916l-10 3c-.95.285-.95 1.631 0 1.916l10 3a1 1 0 0 0 .574-1.916L6.48 8l6.807-2.042Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessThan);
export default __webpack_public_path__ + "static/media/less-than.75fa87ddf56167bb06d52582734219dd.svg";
export { ForwardRef as ReactComponent };